import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { BehaviorSubject, combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import { TabLinkItem } from '@api-ui-app/src/app/shared/lib/tab-link-item';

@Component({
  selector: 'gd-product-catalogue-templates-list-page-tab-links',
  templateUrl: './product-catalogue-templates-list-page-tab-links.component.html',
  styleUrls: ['./product-catalogue-templates-list-page-tab-links.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductCatalogueTemplatesListPageTabLinksComponent {
  @Input() set rootPath(rootPath: string) {
    this.rootPath$.next(rootPath);
  }
  @Input() set isTemplatesTabActive(isTemplatesTabActive: boolean) {
    this.isTemplatesTabActive$.next(isTemplatesTabActive);
  }

  private readonly rootPath$ = new BehaviorSubject<string>(null);
  private readonly isTemplatesTabActive$ = new BehaviorSubject<boolean>(false);

  readonly tabs$ = combineLatest([this.rootPath$, this.isTemplatesTabActive$]).pipe(
    map(([rootPath, isTemplatesTabActive]): TabLinkItem[] => [
      {
        translationKey: 'txt_tab_product_catalog',
        routerLink: [rootPath, 'categories'],
        isActive: !isTemplatesTabActive,
      },
      {
        translationKey: 'txt_tab_my_templates',
        routerLink: [rootPath, 'templates'],
        isActive: isTemplatesTabActive,
      },
    ]),
  );
}
